// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q1_ia","option":"styles_option___EdI0","active":"styles_active__2EjBj"};